module.exports = __webpack_public_path__ + "img/pdt_item03.ac2448a8.svg";